var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "variation-availability-container",
      class: _vm.attributeType,
    },
    [
      _vm.fromPrice != null
        ? [
            _c(
              "div",
              { staticClass: "availability-text" },
              [
                _vm.pricePrefix
                  ? [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$translate("Ceres::Template.itemFrom")) +
                          "\n      "
                      ),
                    ]
                  : _vm._e(),
                _vm._v(
                  _vm._s(
                    _vm._f("currency")(
                      _vm.fromPrice,
                      _vm.currentVariation.prices.default.currency
                    )
                  ) + "\n    "
                ),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        class: "verfuegbarkeit availability-" + _vm.availabilityColor,
        attrs: { id: _vm.attributeId + "-" + _vm.attributeValueId },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }